const ORDER_TRADE_IN_LOOKUP_RESULT_COMPONENTS = (() => {
  const resultContainer = ({ href }) => {
    const container = document.createElement('a');
    container.className = 'order-trade-in-lookup-result__container';
    container.href = href;

    return container;
  };

  const mainIdentifier = ({ identifierText }) => {
    const container = document.createElement('div');
    container.className = 'order-trade-in-lookup-result__main-identifier-container p-bold';
    
    const mainIdentifier = document.createElement('div');
    mainIdentifier.className = 'order-trade-in-lookup-result__main-identifier';
    mainIdentifier.textContent = identifierText;
    container.appendChild(mainIdentifier);

    const icon = document
      .getElementById('order-trade-in-results__result-icon-template')
      .content
      .cloneNode(true);
    container.appendChild(icon);

    return container;
  };

  const detailRow = () => {
    const row = document.createElement('div');
    row.className = 'order-trade-in-lookup-result__detail-row';
    return row;
  };

  const detailRowWithLabel = ({ labelText, valueText }) => {
    const row = detailRow();

    const label = document.createElement('span');
    label.className = 'order-trade-in-lookup-result__detail-label';
    label.textContent = labelText;
    row.appendChild(label);

    const value = document.createElement('span');
    value.className = 'p-bold';
    value.textContent = valueText;
    row.appendChild(value);

    return row;
  };

  const thumbnails = ({ images }) => {
    const container = document.createElement('order-trade-in-lookup-result-thumbnails');
    container.images = images;
    return container;
  };

  return {
    detailRow,
    detailRowWithLabel,
    mainIdentifier,
    resultContainer,
    thumbnails,
  };
})();
